export enum InvoiceUiPaymentStatusEnum {
  AwaitingAcceptance = 1,
  Accepted = 2,
}
